import { Shield, TrendingUp, Zap } from 'lucide-react';

import { CaseStudy } from '../types/types';

export const caseStudies: CaseStudy[] = [
  {
    id: 1,
    title: 'Optimización de Procesos en Fabricajas (Sociedad Yu spa)',
    description:
      'Implementación de un sistema integral de automatización y control de producción que revolucionó la eficiencia operativa y la calidad del producto.',
    results: [
      {
        metric: 'Mantenimiento Correctivo',
        value: '-90%',
        icon: Shield,
      },
      {
        metric: 'Mantenimiento Preventivo',
        value: '+90%',
        icon: Shield,
      },
      {
        metric: 'Eficiencia Energética',
        value: '+40%',
        icon: Zap,
      },
      {
        metric: 'Calidad del Producto',
        value: '+25%',
        icon: TrendingUp,
      },
    ],
    industry: 'Manufactura',
    image:
      'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',
    client: {
      name: 'Fabricajas (Sociedad Yu spa)',
      logo: '/clients/fabricajas-logo.png',
    },
    duration: '6 meses',
    tags: ['Automatización Industrial', 'Control de Producción', 'Eficiencia Operativa'],
  },
  {
    id: 2,
    title: 'Gestión de Contratos en Proyectos de Transmisión Eléctrica',
    description:
      'Liderazgo en gestión de contratos y análisis de rentabilidad para proyectos de transmisión eléctrica nacionales e internacionales, garantizando el éxito operativo y económico.',
    results: [
      {
        metric: 'Recuperación Económica',
        value: '+30%',
        icon: TrendingUp,
      },
      {
        metric: 'Rentabilidad',
        value: '+0.82%',
        icon: Shield,
      },
      {
        metric: 'Eficiencia Operativa',
        value: '+60%',
        icon: Zap,
      },
      {
        metric: 'Cumplimiento de Proyectos',
        value: '100%',
        icon: TrendingUp,
      },
    ],
    industry: 'Energía',
    image:
      'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',
    client: {
      name: 'Grupo Cobra',
      logo: '/clients/grupo-cobra-logo.png',
    },
    duration: '18 meses',
    tags: [
      'Gestión de Contratos',
      'Análisis de Rentabilidad',
      'Transmisión Eléctrica',
      'Proyectos Internacionales',
    ],
  },
  {
    id: 3,
    title: 'Adopción del Servicio de Comunicaciones Unificadas HCS en Entel',
    description:
      'Desarrollo de estrategias y planes de adopción para el servicio de comunicaciones unificadas HCS, enfocado en mejorar la experiencia del cliente corporativo.',
    results: [
      {
        metric: 'Documentación Estratégica',
        value: '100%',
        icon: Shield,
      },
      {
        metric: 'Coordinación con Clientes',
        value: 'Efectiva',
        icon: TrendingUp,
      },
      {
        metric: 'Metodologías Ágiles',
        value: 'Implementadas',
        icon: Zap,
      },
    ],
    industry: 'Telecomunicaciones',
    image:
      'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',
    client: {
      name: 'Entel SA Chile',
      logo: '/clients/entel-logo.png',
    },
    duration: '3 meses',
    tags: [
      'Comunicaciones Unificadas',
      'Desarrollo de Productos',
      'Metodologías Ágiles',
      'Gestión de Clientes',
    ],
  },
];
